import React, { FC } from 'react'
import classNames from 'classnames'

import { onlyNumbersAllowed } from 'utils/helpers/input'
import { VERIFICATION_CODE_LENGTH } from 'utils/constants/input'
import { Text, Input } from 'components/ui-kit'
import { SvgIcon } from 'components/icon'
import { ConfirmationDialog } from 'components/dialog/ConfirmationDialog'

import styles from './VerifyEmailModalView.module.scss'

interface Props {
  isOpen: boolean
  isReady: boolean
  isPending: boolean
  isCodeWasSent: boolean
  handleModalHide: () => void
  handleModalShow: () => void
  handleVerifyEmail: () => void
  handleInputChange: (value: string) => void
  handleSendNewCode: () => void
  verificationCode?: string
  email?: string
}

export const VerifyEmailModalView: FC<Props> = ({
  isOpen,
  isReady,
  isPending,
  isCodeWasSent,
  handleModalShow,
  handleModalHide,
  email,
  verificationCode,
  handleInputChange,
  handleSendNewCode,
  handleVerifyEmail,
}) => (
  <ConfirmationDialog
    isPending={isPending}
    isReady={isReady}
    show={isOpen}
    onShow={handleModalShow}
    onHide={handleModalHide}
    discardBtnLabel="Cancel"
    confirmBtnLabel="Verify"
    buttonSize="big"
    className={styles.modalWrapper}
    onConfirm={handleVerifyEmail}
    backdrop="static"
    title="Verify Email">
    <Text type="body-3">
      We have sent you a temporary verification code to <b>{email}.</b>&nbsp; Enter the code to verify your email.
    </Text>
    <br />
    <div className={styles.codeContainer}>
      <Text type="body-2" className={styles.title}>
        Verification Code
      </Text>
      <br />
      <Input
        value={verificationCode}
        onChange={handleInputChange}
        placeholder="- - - -"
        maxLength={VERIFICATION_CODE_LENGTH}
        validationPattern={onlyNumbersAllowed}
      />
    </div>
    <div
      className={classNames(styles.codeActionContainer, {
        [styles.codeWasSent]: isCodeWasSent,
      })}>
      <div key="code-was-sent" className={classNames(styles.codeAction, styles.successSent)}>
        <SvgIcon name="completed" /> <span>Code has been sent.</span>
      </div>
      <div
        key="send-new-code"
        className={classNames(styles.codeAction, styles.refreshCode)}
        onClick={handleSendNewCode}>
        <SvgIcon name="circle-arrow" /> <span>Send a New Code</span>
      </div>
    </div>
  </ConfirmationDialog>
)
